<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  placeholder="请输入项目名称"
                  size="small"
                  clearable
                  style="width: 200px"
                ></el-input>

                <el-select
                  v-model="search.project_type"
                  placeholder="请选择项目类型"
                  clearable
                  size="small"
                >
                  <el-option label="手术项目" :value="1"></el-option>
                  <el-option label="非手术项目" :value="2"></el-option>
                </el-select>

                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="getTableList(1,search)"
                >搜索</el-button>
              </el-card>

              <el-card style="margin-top:10px">
                <el-table
                  :data="table_data"
                  style="width: 100%"
                  border
                  lazy
                  @expand-change="expandChange"
                  :row-class-name="getRowClassName"
                >
                  <el-table-column type="expand" prop="children">
                    <template slot-scope="scope">
                      <el-table :data="scope.row.children" style="width: 100%" border>
                        <el-table-column label="项目名称" min-width="200" prop="project_name"
                          align="center"
                          show-overflow-tooltip>
                          <template slot-scope="scope">
                            <span>{{ scope.row.project_name }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="申请时间" width="180" prop="apply_time" align="center"></el-table-column>
                        <el-table-column
                          label="项目负责人信息"
                          width="300"
                          prop="project_master"
                          align="center"
                          show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column label="分配/剩余/已拨" align="center" width="350">
                          <template slot-scope="scope">
                            {{scope.row.top_money | setNumFormat}} / {{scope.row.apply_balance | setNumFormat}} / {{scope.row.payment_pay_money_sum | setNumFormat}}
                          </template>
                        </el-table-column>
                        <el-table-column label="项目状态" align="center" width="150">
                          <template slot-scope="scope">
                            <span
                              style="color:red;text-decoration: underline; cursor: pointer;"
                              v-if="scope.row.foundagree == 2"
                            >
                              <el-popover
                                placement="top"
                                title="审核意见："
                                width="200"
                                trigger="click"
                                :content="scope.row.found_opinion"
                              >
                                <span slot="reference">{{scope.row.foundagree_text}}</span>
                              </el-popover>
                            </span>
                            <span
                              v-else
                              :style="{color:scope.row.foundagree == 1?'green':'#606266'}"
                            >{{scope.row.foundagree_text}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="结项状态" align="center" width="150">
                          <template slot-scope="scope">
                            <span
                              style="color:red;text-decoration: underline; cursor: pointer;"
                              v-if="scope.row.node_status == 2"
                            >
                              <el-popover
                                placement="top"
                                title="结项审核意见："
                                width="200"
                                trigger="click"
                                :content="scope.row.node_status_audit_opinion"
                              >
                                <span slot="reference">{{scope.row.node_status_text}}</span>
                              </el-popover>
                            </span>
                            <span
                              v-else
                              :style="{color:scope.row.node_status == 1?'green':'#606266'}"
                            >{{scope.row.node_status_text}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="220">
                          <template slot-scope="scope">
                            <el-button-group>
                              <template v-if="scope.row.is_edit">
                                <el-button
                                  size="mini"
                                  type="primary"
                                  icon="el-icon-edit"
                                  @click="doEdit(scope.row)"
                                >编辑</el-button>

                                <el-button
                                  size="mini"
                                  type="danger"
                                  icon="el-icon-delete-solid"
                                  @click="doDelete(scope.row)"
                                >删除</el-button>
                              </template>
                              <template v-else>
                                <el-button
                                  type="primary"
                                  icon="el-icon-view"
                                  style="padding: 5px 7px"
                                  size="mini"
                                  @click="showApplyDetail(scope.row)"
                                >申请详情</el-button>
                                <el-button
                                  type="danger"
                                  icon="el-icon-finished"
                                  style="padding: 5px 7px"
                                  size="mini"
                                  v-if="scope.row.is_node"
                                  @click="showProjectEnd(scope.row)"
                                >{{Number(scope.row.node_id) > 0?'修改结项':'项目结项'}}</el-button>
                              </template>
                            </el-button-group>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column label="序号" prop="key" min-width="65" align="center">
                    <template slot-scope="scope">{{scope.row.key}}</template>
                  </el-table-column>
                  <el-table-column label="项目名称" prop="project_name" min-width="300">
                    <template slot-scope="scope">
                      <a href="JavaScript:;" @click="goDetail(scope.row)">{{scope.row.project_name}}</a>
                      <el-tag
                        type="danger"
                        style="margin-left:10px"
                        size="small"
                        v-if="scope.row.if_end==1"
                      >项目已结束</el-tag>
                      <div style="color:#666">{{scope.row.regdate_start}}至{{scope.row.regdate_end}}</div>
                    </template>
                  </el-table-column>

                  <el-table-column label="项目分类" prop="cat_name" align="center" min-width="150"></el-table-column>
                  <el-table-column
                    label="项目类别"
                    prop="project_type_text"
                    align="center"
                    min-width="150"
                  ></el-table-column>

                  <el-table-column label="申请情况" align="center" width="150">
                    <template slot-scope="scope">
                      <span v-if="scope.row.apply_count > 0">
                        <el-popover
                          placement="top"
                          title="说明："
                          width="250"
                          trigger="hover"
                          content="该项目总申请次数 / 申请未审核次数 / 审核不通过次数"
                        >
                          <span slot="reference">
                            {{scope.row.apply_count + " / " + scope.row.apply_no_audit_count + " / "}}
                            <span
                              :style="{color:scope.row.apply_audit_failed_count > 0?'red':'#606266'}"
                            >{{scope.row.apply_audit_failed_count}}</span>
                          </span>
                        </el-popover>
                      </span>
                      <span v-else>未申请</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" align="center" width="220">
                    <template slot-scope="scope">
                      <el-button-group>
                        <template v-if="scope.row.if_option">
                          <el-button
                            type="primary"
                            icon="el-icon-edit"
                            size="mini"
                            @click="doLaunch(scope.row)"
                          >申请项目</el-button>
                        </template>
                        <!-- <template v-else> -->
                        <!-- <el-button
                            type="primary"
                            icon="el-icon-edit"
                            size="mini"
                            @click="doRepot(scope.row.id)"
                        >提交报告</el-button>-->

                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          @click="doMedia(scope.row)"
                        >媒体报道</el-button>
                        <!-- </template> -->
                      </el-button-group>
                    </template>
                  </el-table-column>
                  <!-- </template> -->
                </el-table>

                <div style="text-align: center;margin-top: 15px">
                  <el-pagination
                    :total="table_total"
                    background
                    layout="prev, pager, next"
                    :page-size="10"
                    hide-on-single-page
                    @current-change="getTableList($event,{})"
                  ></el-pagination>
                </div>
              </el-card>

              <el-dialog :visible.sync="endShow" append-to-body title="申请项目结项">
                <el-form :model="endForm" :rules="endRules" label-position="top" ref="endFormRef">
                  <el-form-item label="结项原因：" prop="reasons">
                    <el-input
                      type="textarea"
                      placeholder="请填写结项原因"
                      v-model.trim="endForm.reasons"
                      :rows="3"
                      :maxlength="300"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-form>

                <span slot="footer">
                  <el-button @click="endClose">取 消</el-button>
                  <el-button type="primary" @click="endSubmit" :loading="endLoading">确 定</el-button>
                </span>
              </el-dialog>

              <info
                v-if="if_open"
                v-model="if_open"
                :pid="project_id"
                :aid="apply_id"
                :type="project_type"
                :look="if_look"
                :title="info_title"
                @success="success"
              ></info>
              <detail v-if="if_open2" v-model="if_open2" :pid="project_id"></detail>
              <media
                v-if="if_open3"
                v-model="if_open3"
                :title="media_title"
                :id="project_id"
                :type="2"
              ></media>
            </div>
          </el-col>
        </el-row>
        <!-- Form -->
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import baseUrl from "@/config/index";
import info from "./info";
import detail from "./detail";
import media from "./media";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    info,
    detail,
    media
  },
  data() {
    return {
      search: {},
      table_data: [], //表格数据
      table_total: 0,

      //结项 start
      endLoading: false,
      endShow: false,
      endForm: { reasons: "", project_apply_id: null },
      endRules: {
        reasons: [
          { required: true, message: "请填写结项原因", trigger: "blur" }
        ]
      },
      //结项 end

      if_look: false,

      if_open: false, //发起项目框
      if_open2: false, //详情弹框
      if_open3: false, //媒体报道
      media_title: "", //媒体报道名称

      apply_id: null, //项目申请id

      project_id: null, //
      project_type: 1, //1代表手术项目
      info_title: "申请项目信息"
    };
  },
  methods: {
    // //  选择申请类别
    // selType(val) {
    //   if (val == 1 || val == 2) {
    //     this.search.if_apply = val;
    //     this.$refs.tables.handleSearch();
    //   } else {
    //     if (val == 3) {
    //       this.search.if_apply = null;
    //     }
    //     this.$refs.tables.handleSearch();
    //   }
    // },

    // 申请结项
    showProjectEnd(row) {
      this.endForm.project_apply_id = row.project_apply_id;

      if (Number(row.node_id) > 0) {
        this.$db
          .post(this.$db.config.cf_project.info.end_info, {
            id: row.node_id
          })
          .then(res => {
            if (res.code == 200) {
              this.endForm = res.data;
              this.endShow = true;
            }
          });
      } else {
        this.endShow = true;
      }
    },

    //结项取消操作
    endClose() {
      // this.$refs.endFormRef.resetField();
      this.endShow = false;
      this.endLoading = false;
    },

    //结项提交
    endSubmit() {
      this.$refs["endFormRef"].validate(valid => {
        if (valid) {
          this.endLoading = true;
          let url = Number(this.endForm.id > 0)
            ? this.$db.config.cf_project.info.end_edit
            : this.$db.config.cf_project.info.apply_end;
          this.$db.post(url, this.endForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getTableList();
            }
            this.endClose();
          });
        } else {
          this.$message.warning("请填写完整表单信息！");
          return false;
        }
      });
    },

    getRowClassName({ row, rowIndex }) {
      if (row.apply_count == 0) {
        return "row-expand-cover";
      }
    },

    //展开关闭某一列
    expandChange(row, expandedRows) {
      if (expandedRows && expandedRows.length > 0) {
        this.$db
          .post(this.$db.config.cf_project.info.child_list, {
            project_id: row.id
          })
          .then(res => {
            row.children = res.data;
          });
      }
    },

    //获取列表数据
    getTableList(page = 1, serach = {}) {
      let params = { page: page, page_size: 10 };
      Object.assign(params, serach);

      this.$db.post(this.$db.config.cf_project.info.list, params).then(res => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].children = [];
          }
          this.table_data = res.data.data;
          this.table_total = res.data.total;
        }
      });
    },

    // load(tree, treeNode, resolve) {
    //   this.$db
    //     .post(this.$db.config.cf_project.info.child_list, {
    //       project_id: tree.id
    //     })
    //     .then(res => {
    //       resolve(res.data);
    //     });
    // },

    //查看项目详情
    goDetail(row) {
      this.if_open2 = true;
      this.project_id = row.id;
    },

    //发起项目
    doLaunch(data) {
      this.project_id = data.id;
      this.apply_id = null;
      this.project_type = data.project_type;
      this.info_title = data.project_name;
      this.if_look = false;
      this.if_open = true;
    },

    //编辑申请
    doEdit(data) {
      this.project_id = data.project_id;
      this.apply_id = data.project_apply_id;
      this.project_type = data.project_type;
      this.info_title = data.project_name;
      this.if_look = false;
      this.if_open = true;
    },

    //删除申请操作
    doDelete(row) {
      this.$confirm("确定要删除该条申请信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$db
            .post(this.$db.config.cf_project.info.apply_del, {
              id: row.project_apply_id
            })
            .then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.getTableList();
              }
            });
        })
        .catch(() => {});
    },

    //查看申请详情
    showApplyDetail(data) {
      this.project_id = data.project_id;
      this.apply_id = data.project_apply_id;
      this.project_type = data.project_type;
      this.info_title = data.project_name;
      this.if_look = true;
      this.if_open = true;
    },

    success() {
      this.getTableList();
    },
    //提交报告
    doRepot(id) {
      this.$router.push({ name: "cfProSubmitReport", query: { pid: id } });
    },

    //提交媒体报道
    doMedia(row) {
      this.project_id = row.id;
      this.if_open3 = true;
      this.media_title = row.project_name;
      // this.$router.push({ name: "cfProSubmitMedia", query: { id: id } });
    }
  },

  mounted() {
    this.getTableList();
  }
};
</script>
<style lang="scss">
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      overflow: hidden;
      .row-expand-cover .el-table__expand-icon {
        display: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/list.vue